import React, { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import PostCard from "./PostCard";
import { useNavigate } from "react-router-dom";
import SearchWidget from "../../components/SearchWidget";

export default function PostFilterTab({
                                          products = [],
                                          categories = [],
                                          targetCategoryId,
                                          currentPage,
                                          itemsPerPage,
                                          onPageChange
                                      }) {

    const navigate = useNavigate();
    const [filterData, setFilterData] = useState(products);
    const [activeCategory, setActiveCategory] = useState(null);

    useEffect(() => {
        setFilterData(products);
    }, [products]);

    useEffect(() => {
        if (!products || products.length === 0) {
            setFilterData([]);
            return;
        }

        const filtered = products.filter((product) => {
            const categoryMatch =
                activeCategory === null ||
                product.categories.includes(activeCategory);

            const searchMatch =
                product.title.rendered &&
                product.title.rendered.toLowerCase();

            return categoryMatch && searchMatch;
        });

        setFilterData(filtered);
    }, [products, activeCategory]);

    const totalItems = filterData.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentPosts = filterData.slice(startIndex, endIndex);

    useEffect(() => {
        if(targetCategoryId) {
            setActiveCategory(targetCategoryId);
            onPageChange(1, totalPages);
        }
    }, [onPageChange, targetCategoryId, totalPages]);

    const generatePageNumbers = () => {
        const pageNumbers = [];
        for (let i = Math.max(1, currentPage - 2); i <= Math.min(totalPages, currentPage + 2); i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    const handleFilter = (selectedCategory) => {
        setActiveCategory(selectedCategory);
        onPageChange(1, totalPages);
    };

    const pageNumbers = generatePageNumbers();

    return (
        <div className="default-tabs tabs-box">
            {categories.length > 0 && (
                <ul className="tab-buttons blog">
                        <>
                            {/*<li key="tab-all"*/}
                            {/*    className={`tab-btn ${activeCategory === null ? "active-btn" : ""}`}*/}
                            {/*    onClick={() => {*/}
                            {/*        !targetCategoryId*/}
                            {/*            ? handleFilter(null)*/}
                            {/*            : navigate("/blog");*/}
                            {/*    }}>*/}
                            {/*    Tous*/}
                            {/*</li>*/}
                            {/*{categories.map((cat) => (*/}
                            {/*    <li key={`tab-${cat.id}`}*/}
                            {/*        className={`tab-btn ${activeCategory === cat.id ? "active-btn" : ""}`}*/}
                            {/*        onClick={() => handleFilter(cat.id)}>*/}
                            {/*        {cat.name}*/}
                            {/*    </li>*/}
                            {/*))}*/}
                            <li className="search-container" >
                                <SearchWidget/>
                            </li>
                        </>
                </ul>
            )}

            <div className="tabs-content fadeInUp animated">
                <div className="tab active-tab">
                    <div className="row ">
                        <div className="content-side col-lg-12 col-md-12 col-sm-12 justify-content-between">
                            <div className="blog-grid" style={{ display: "flex", flexWrap: "wrap" }}>
                                <AnimatePresence>
                                    {currentPosts.length === 0 ? (
                                        <p>Aucun article trouvé.</p>
                                    ) : (
                                        currentPosts.map((product) => (
                                            product && (
                                                <PostCard key={product.id}
                                                          product={product}
                                                          colLg="4"
                                                />
                                            )
                                        ))
                                    )}
                                </AnimatePresence>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {totalItems > 0 && (
                <nav className="ls-pagination">
                    <ul>
                        <li className={`prev ${currentPage === 1 ? 'disabled' : ''}`}>
                            <button onClick={() => onPageChange(currentPage - 1, totalPages)}
                                    disabled={currentPage === 1}>
                                <i className="fa fa-arrow-left"></i>
                            </button>
                        </li>

                        {currentPage > 3 && (
                            <>
                                <li>
                                    <button onClick={() => onPageChange(1, totalPages)}>1</button>
                                </li>
                                {currentPage > 4 && <li className="disabled"><span>&hellip;</span></li>}
                            </>
                        )}

                        {pageNumbers.map(page => (
                            <li key={page}>
                                <button className={page === currentPage ? 'current-page' : ''}
                                   onClick={() => onPageChange(page, totalPages)}>
                                    {page}
                                </button>
                            </li>
                        ))}

                        {currentPage < totalPages - 2 && (
                            <>
                                {currentPage < totalPages - 3 && <li className="disabled"><span>&hellip;</span></li>}
                                <li><button onClick={() => onPageChange(totalPages, totalPages)}>{totalPages}</button></li>
                            </>
                        )}

                        <li className={`next ${currentPage === totalPages ? 'disabled' : ''}`}>
                            <button
                                onClick={() => onPageChange(currentPage + 1, totalPages)}
                                disabled={currentPage === totalPages}
                            >
                                <i className="fa fa-arrow-right"></i>
                            </button>
                        </li>
                    </ul>
                </nav>
            )}
        </div>
    );
}
